import Contract from "../artifacts/contracts/votingDAO.sol/VotingDAO.json";

export const contractAddress = "0x6876A5bB2f8182472e0eDc081C871b51089cf97e";
export const contractAbi = Contract.abi;
